import {
  McleodCommodityOption,
  ValueLabelOption,
} from 'pages/QuoteView/LoadBuilding/McleodSectionForms/types';

export const larkinTransportTypeOptions: ValueLabelOption[] = [
  { value: '10AX', label: '10AX - 10 Axle Setup' },
  { value: '11AX', label: '11AX - 11 axle Setup' },
  { value: '1X', label: '1X - 1 AXLE' },
  { value: '13AX', label: '13AX - 13 AXLE' },
  { value: '19AX', label: '19AX - 19 AX trailer' },
  { value: '20OT', label: '20OT - 20FT OPEN TOP CONTAINER' },
  { value: '40OT', label: '40OT - 40 ft open top container' },
  { value: '53CN', label: "53CN - 53' Conestoga" },
  { value: '53FB', label: "53FB - 53' Flatbed" },
  { value: '53SD', label: "53SD - 53'Step Deck" },
  { value: '9X', label: '9X - 9 Axle Setup' },
  { value: 'AC', label: 'AC - Auto Carrier (DAT)' },
  { value: 'BEAM', label: 'BEAM - BeamTrailer' },
  { value: 'BT', label: 'BT - Flatbed B-Train (DAT)' },
  { value: 'C', label: 'C - Container (DAT)' },
  { value: 'CH', label: 'CH - Chassis' },
  { value: 'CI', label: 'CI - Continer, Insulated (DAT)' },
  { value: 'CN', label: 'CN - Conestoga (DAT)' },
  { value: 'COW', label: 'COW - Container - Overweight' },
  { value: 'CR', label: 'CR - Conter Refrigerate (DAT)' },
  { value: 'CV', label: 'CV - Conveyor (DAT)' },
  { value: 'D', label: 'D - Dump Truck' },
  { value: 'DD', label: 'DD - Double Drop (DAT)' },
  { value: 'DDT', label: 'DDT - Drop Deck Trailers' },
  { value: 'DT', label: 'DT - Dump Trailer (DAT)' },
  { value: 'DUAL', label: 'DUAL - Dual Track Transport / Suspension Beam' },
  { value: 'ETRA', label: 'ETRA - E-TRAC TRAILER' },
  { value: 'EXDD', label: 'EXDD - EXtendable Double drop' },
  { value: 'EXSD', label: 'EXSD - Extendable Step Deck' },
  { value: 'EXT', label: 'EXT - Extenable Trailer' },
  { value: 'F', label: 'F - Flatbed (DAT)' },
  { value: 'FA', label: 'FA - Flatbed Airride (DAT)' },
  { value: 'FBO', label: 'FBO - FlatBed OD' },
  { value: 'FC', label: 'FC - Flatbed wty chains (DAT)' },
  { value: 'FD', label: 'FD - Flatbed or Step Deck (DAT)' },
  { value: 'FDO', label: 'FDO - Flat / Step OD' },
  { value: 'FH', label: 'FH - Flatbed Hotshot (DAT)' },
  { value: 'FM', label: 'FM - Flatbed w/ Team (DAT)' },
  { value: 'FN', label: 'FN - Flatbed Conestoga (DAT)' },
  { value: 'FO', label: 'FO - Flatbed Overs/Dimnsn' },
  { value: 'FORK', label: 'FORK - Forklift / Lifting Service' },
  { value: 'FR', label: 'FR - Flat Rack' },
  { value: 'FT', label: 'FT - Flatbed w/Tarps (DAT)' },
  { value: 'FZ', label: 'FZ - Flatbed Hazmat (DAT)' },
  { value: 'HB', label: 'HB - Hopper bottom (DAT)' },
  { value: 'IR', label: 'IR - Insulated Van | Reefer (DAT)' },
  { value: 'LA', label: 'LA - Drop Deck, Landoll (DAT)' },
  { value: 'LB', label: 'LB - Lowboy (DAT)' },
  { value: 'LO', label: 'LO - Lowboy Overdimension (DAT)' },
  { value: 'LOG', label: 'LOG - Forestry Trailers' },
  { value: 'LSD', label: 'LSD - LOW PRO STEP DECK' },
  { value: 'LR', label: 'LR - Lowboy or RGN (DAT)' },
  { value: 'MINI', label: 'MINI - Mini Deck' },
  { value: 'MV', label: 'MV - Moving van (DAT)' },
  { value: 'MX', label: 'MX - Flatbed Maxi (DAT)' },
  { value: 'NU', label: 'NU - Pneumatic (DAT)' },
  { value: 'O', label: 'O - Other' },
  { value: 'OT', label: 'OT - Van Opentop (DAT)' },
  { value: 'PO', label: 'PO - Power Only (DAT)' },
  { value: 'R', label: 'R - Reefer (DAT)' },
  { value: 'R2', label: 'R2 - Reefer Doubles (DAT)' },
  { value: 'RA', label: 'RA - Reefer Airride (DAT)' },
  { value: 'RAL', label: 'RAL - INTERMODAL RAIL' },
  { value: 'RG', label: 'RG - Removable GooseNeck (DAT)' },
  { value: 'RL', label: 'RL - Reefer Logistics (DAT)' },
  { value: 'RM', label: 'RM - Reefer w/ Team (DAT)' },
  { value: 'RN', label: 'RN - Reefer Intermodal (DAT)' },
  { value: 'RP', label: 'RP - Reefer Pallet exchange (DAT)' },
  { value: 'RV', label: 'RV - Reefer or Vented Van' },
  { value: 'RZ', label: 'RZ - Reefer Hazmat (DAT)' },
  { value: 'SB', label: 'SB - Straight Box trck' },
  { value: 'SBT', label: 'SBT - Straight Box Trucks' },
  { value: 'SD', label: 'SD - Step Deck (DAT)' },
  { value: 'SDO', label: 'SDO - Stepdeck OD' },
  { value: 'SDS', label: 'SDS - Steerable Dolley' },
  { value: 'SN', label: 'SN - Stepdeck Conestoga (DAT)' },
  { value: 'SO', label: 'SO - Step OD' },
  { value: 'SPMT', label: 'SPMT' },
  { value: 'SPR', label: 'SPR - Sprinter' },
  { value: 'SR', label: 'SR - Step Deck or RGN' },
  { value: 'ST', label: 'ST - Stretch Trailer (DAT)' },
  { value: 'TA', label: 'TA - Tanker Aluminuim (DAT)' },
  { value: 'TN', label: 'TN - Tanker Intermodal (DAT)' },
  { value: 'TRA', label: 'TRA - Transloading' },
  { value: 'TRC', label: 'TRC - Truck - Route Survey' },
  { value: 'TS', label: 'TS - Tanker Steel (DAT)' },
  { value: 'TT', label: 'TT - Truck and Trailer (DAT)' },
  { value: 'V', label: 'V - Van (DAT)' },
  { value: 'V2', label: 'V2 - Van Double (DAT)' },
  { value: 'VA', label: 'VA - Van Airride (DAT)' },
  { value: 'VB', label: 'VB - Van Roller Bed (DAT)' },
  { value: 'VC', label: 'VC - Van curtain (DAT)' },
  { value: 'VF', label: 'VF - Van or Flatbed (DAT)' },
  { value: 'VG', label: 'VG - Van Lift-Gate (DAT)' },
  { value: 'VH', label: 'VH - Van Hotshot (DAT)' },
  { value: 'VI', label: 'VI - Van Insulated (DAT)' },
  { value: 'VL', label: 'VL - Van Logistics' },
  { value: 'VTL', label: 'VTL - Van - LTL' },
  { value: 'VM', label: 'VM - Van w/ Team (DAT)' },
  { value: 'VN', label: 'VN - Van Intermodal (DAT)' },
  { value: 'VP', label: 'VP - Van Pallet Exchange (DAT)' },
  { value: 'VR', label: 'VR - Van or Reefer (DAT)' },
  { value: 'VS', label: 'VS - Van Conestoga (DAT)' },
  { value: 'VT', label: 'VT - Van on Flats w/Tarps (DAT)' },
  { value: 'VV', label: 'VV - Van Vented (DAT)' },
  { value: 'VW', label: 'VW - Van Blanket Wrap' },
  { value: 'VZ', label: 'VZ - Van Hazmat (DAT)' },
  { value: 'WRH', label: 'WRH - WAREHOUSE' },
];

export const larkinRevenueCodes: ValueLabelOption[] = [
  { value: 'ADM', label: 'ADM - Admin' },
  { value: 'AIRF', label: 'AIRF - Air Freight' },
  { value: 'BUFF', label: 'BUFF - Buffalo' },
  { value: 'CHARL', label: 'CHARL - Charleston' },
  { value: 'CHAT', label: 'CHAT - Chattanooga' },
  { value: 'GREEN', label: 'GREEN - Greensboro' },
  { value: 'GRVL', label: 'GRVL - Greenville' },
  { value: 'HEAVY', label: 'HEAVY - Heavy Haul Div' },
  { value: 'HOUS', label: 'HOUS - Houston' },
  { value: 'IND', label: 'IND - Indianapolis' },
  { value: 'LTL', label: 'LTL' },
  { value: 'NORFO', label: 'NORFO - Norfolk' },
  { value: 'WAREH', label: 'WAREH - Warehousing' },
];

export const larkinOrderTypes: ValueLabelOption[] = [
  { value: 'AIR', label: 'AIR' },
  { value: 'CONTAIN', label: 'CONTAIN - Container' },
  { value: 'EXP', label: 'EXP - Expedited' },
  { value: 'LEGAL', label: 'LEGAL' },
  { value: 'LTL', label: 'LTL - LTL   Less Than Truckload' },
  { value: 'MEXICO', label: 'MEXICO' },
  { value: 'MUNTERS', label: 'MUNTERS' },
  { value: 'OD', label: 'OD - Overdimensional' },
  { value: 'RAIL', label: 'RAIL' },
  { value: 'SUPER', label: 'SUPER - Super loads' },
  { value: 'TRANSL', label: 'TRANSL - TRANSLOAD' },
  { value: 'VAN', label: 'VAN' },
];

export const larkinCommodityOptions: McleodCommodityOption[] = [
  {
    code: '01-05',
    description: 'Animal & Animal Products',
    hazmat: 'N',
    un: '',
  },
  {
    code: '06-15',
    description: 'Vegetable Products',
    hazmat: 'N',
    un: '',
  },
  {
    code: '25-27',
    description: 'Mineral Produts',
    hazmat: 'N',
    un: '',
  },
  {
    code: '28-38',
    description: 'Chemicals',
    hazmat: 'N',
    un: '',
  },
  {
    code: '40FR',
    description: "40'FR",
    hazmat: 'N',
    un: '',
  },
  {
    code: '41-43',
    description: 'Raw Hides, Skins, Leather & Furs',
    hazmat: 'N',
    un: '',
  },
  {
    code: '44-49',
    description: 'Wood & Wood Products',
    hazmat: 'N',
    un: '',
  },
  {
    code: '50-63',
    description: 'Textiles',
    hazmat: 'N',
    un: '',
  },
  {
    code: '64-67',
    description: 'Footwear / Headgear',
    hazmat: 'N',
    un: '',
  },
  {
    code: '68-71',
    description: 'Stone / Glass',
    hazmat: 'N',
    un: '',
  },
  {
    code: '72-83',
    description: 'Metals',
    hazmat: 'N',
    un: '',
  },
  {
    code: '84-85',
    description: 'Machinery/ Electrical',
    hazmat: 'N',
    un: '',
  },
  {
    code: '86-89',
    description: 'Transportation',
    hazmat: 'N',
    un: '',
  },
  {
    code: '90-97',
    description: 'Miscellaneous',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ABRASIVES',
    description: 'ABRASIVES ON PALLETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ABRGRAIN',
    description: 'ABRASIVE GRAIN',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ACTUATOR',
    description: 'Actuator moving equipment',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ADD',
    description: 'Additives',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ALUMEXTRU',
    description: 'ALUMINUM EXTRUSIONS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ALUMINUM',
    description: 'ALUMINUM',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ALUMINUMS',
    description: 'Aluminum Sulfate',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ALUMPARTS',
    description: 'Aluminum machined parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'AMMLAUNCH',
    description: 'Ammunition, Live Launchers & Parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'AMMUNITIO',
    description: 'UN0012, Cartridges, Small Arms, Class 1.4s (Ammo)',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'APPLIANCE',
    description: 'Appliances',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ARMOR',
    description: 'Armor',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ATHGOOD',
    description: 'Athletic or sporting goods',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ATMS',
    description: 'AUTOMATED TELLERS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'AUTOPARTS',
    description: 'AUTO PARTS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'AUTOPION',
    description: 'AUTO PARTS UN3480 LITHIUM ION BATTERIES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BAGS',
    description: 'Bags',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BALEDPAPE',
    description: 'BALED PAPER',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BALLBEAR',
    description: 'Ball Bearings',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BATHFIX',
    description: 'JANITORIAL / BATH FIXTURES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BATTERIES',
    description: 'Batteries',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BETA',
    description: 'Beta Cyclodextrin',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BEVDISP',
    description: 'Beverge Dispenser',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BICYCLES',
    description: 'BICYCLES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BLANKET',
    description: 'Blanket',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BLENDERS',
    description: 'BLENDERS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BLINDS',
    description: 'BLINDS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BLOW',
    description: 'BLOWER EQUIPMENT',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BOOKS',
    description: 'BOOKS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BOTTLED',
    description: 'BOTTLED WATER',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BOTTLES',
    description: 'BOTTLES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'BUOYS',
    description: 'BUOYS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CABLER',
    description: 'CABLE REELS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CAL',
    description: 'CALCIUM PROPIONATE',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CALCIUM',
    description: 'Calcium',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CARBON',
    description: 'CARBON',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CARDBOARD',
    description: 'Cardboard',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CARTS',
    description: 'CARTS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CASHREG',
    description: 'Cash Registers',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CATERSUPP',
    description: 'Catering Supplies',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CELL',
    description: 'Cellulose Insulation',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CEMENT',
    description: 'Cement Products',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CHAINS',
    description: 'Chains',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CHARCOAL',
    description: 'charcoal',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CLAMPING',
    description: 'CLAMPING FRAME',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CLAMPS',
    description: 'Clamps',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CLAY',
    description: 'clay',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CLEANING',
    description: 'cleaning compounds',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CLOTHING',
    description: 'CLOTHING',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CNC',
    description: 'CNC MACHINE & ACCESSORIES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CNVYRS',
    description: 'conveyors, chutes, plate, trommel, and support stand',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COILS',
    description: 'Coils',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COILTB',
    description: 'Coiled Tubing',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COMMEQUIP',
    description: 'COMMUNICATIONS EQUIPMENT',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COMPRESSO',
    description: 'Compressor',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CONCARG',
    description: 'Consolidated Cargo',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CONSMAT',
    description: 'Construction Materials',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CONSUMER',
    description: 'CONSUMER GOODS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CONVEYER',
    description: 'Conveyor System',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COOK',
    description: 'Cookies',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COOLERS',
    description: 'coolers/refrigerator',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COPPER',
    description: 'Copper',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COSMETICS',
    description: 'COSMETICS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COUPLER',
    description: 'Couplers',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'COVERSCAN',
    description: 'Cover Scan Surface',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CRATED',
    description: 'Crated Machinery',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CROSS',
    description: 'CROSS ARMS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CYBERBAT',
    description: 'CYBERTRUCK BATTERY',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CYLINDER',
    description: 'Cylinder',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'CYLINDERS',
    description: 'Cylinder heads',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'DEAE',
    description: 'Deaerator',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'DECORATIO',
    description: 'Decorations',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'DHTS',
    description: 'DHT Stripper T-801',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'DISMACHIN',
    description: 'DISMANTLED MACHINES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'DUCT',
    description: 'Duct Work',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ELECTRICA',
    description: 'ELECTRICAL SUPPLIES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ELECTRONI',
    description: 'Electronics, Electrical Insulator, Graphic Composite',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'EMPBARR',
    description: 'Empty Barrels',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'EMPTYCYLI',
    description: 'Empty Cylinders',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'EXCAVPART',
    description: 'Excavator Parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'EXXONCHLO',
    description: 'Exxon Chlorobutyl rubber',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FAK',
    description: 'FAK',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FANBLADES',
    description: 'Fan Blades',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FASTENERS',
    description: 'FASTENERS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FERTILIZE',
    description: 'Fertilizer',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIBBIN',
    description: 'Fiber Bins',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIBERHON',
    description: 'Fiber Honeycomb',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIBEROPTI',
    description: 'Fiber Optic Wire & Hardware',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIBRPLY',
    description: 'BUNDLES FIBERBOARD/PLYWOOD',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FILM',
    description: 'FILM',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIREARMS',
    description: 'Firearms',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIREWORKS',
    description: 'Fireworks',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FITTINGS',
    description: 'Fittings',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FIXTURES',
    description: 'Stainless Fixtures',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FLAKES',
    description: 'falkes, pellets, powder',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FLOORING',
    description: 'Flooring',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FLOUR',
    description: 'FLOUR',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FOAM',
    description: 'FOAM - ELFOAM',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FOODADD',
    description: 'Food Additives',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FOUNDRY',
    description: 'Foundry, Die Casting & Permanent Mold Products',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FREEZERPA',
    description: 'FREEZER PANELS & FLOOR LOADED CARTON PAR',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'FURNIPART',
    description: 'furniture parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GAMES',
    description: 'Games',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GENERATOR',
    description: 'Generator',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GIFTWRAP',
    description: 'GIFT WRAP',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GLOVES',
    description: 'Gloves',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GOLFCART',
    description: 'Golf Cart Accessories',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'GRFRTLZR',
    description: 'Granular Fertilizer',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HANDTRUCK',
    description: 'Hand Trucks',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HARDWARE',
    description: 'Hardware',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HEATER',
    description: 'Heaters',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HGDECOR',
    description: 'HOME & GARDEN DECOR',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HOODS',
    description: 'Hoods, Shrouds',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HOUHOGO',
    description: 'Household Goods',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HTO',
    description: 'Heat Treatment Oven',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HUMIDIFIE',
    description: 'Humidifier',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'HYDRAPR',
    description: 'HYDRAULIC PRESS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ICEMELT',
    description: 'Snow and Ice Melter Chloride Pellets',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'INDEX',
    description: 'Indexing Table Machine',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'INK',
    description: 'ink',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'INSTPAN',
    description: 'Instrument Panel',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'INSULATIO',
    description: 'Insulation',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'IRONOXIDE',
    description: 'Iron Oxide',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'KIL',
    description: 'Kiln',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'KNOC',
    description: 'KNOCKED DOWN EMPTY WOODEN CRATES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'LABELS',
    description: 'LABELS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'LABPROD',
    description: 'Lab Products',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'LIFTTRU',
    description: 'Lift Trucks',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'LIGHTING',
    description: 'Lighting fixrues, assemblies, devices',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'LIQUIDFER',
    description: 'Liquid Fertilizer packaged in bottles & boxes on pallets',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'LUMBER',
    description: 'Lumber',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MAGAZINES',
    description: 'Magazines, Catologs, Periodicals',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MARBLE',
    description: 'Marble, granite, Limestone',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MDFBOARD',
    description: 'MDF BOARD',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MEDCARTS',
    description: 'MEDICAL CARTS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MEDIA',
    description: 'Media',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MEDICAL',
    description: 'MEDICAL DEVICES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MEDSUP',
    description: 'Medical Supplies',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'METALMATE',
    description: 'CLEAN METAL MATERIAL',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'METALRING',
    description: 'Metal Rings for Drapes',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'METALSTAM',
    description: 'Metal Stamping',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'METSHE',
    description: 'Metal sheets',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MIRRORS',
    description: 'Mirrors',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ML',
    description: 'Man Lifts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MOTOR',
    description: 'motor',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'MUSINSTM',
    description: 'Musical Instruments',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'NAILS',
    description: 'Roofing Nails',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'NICCAT',
    description: 'Nickel Cathodes',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'NICK',
    description: 'Nickel Briquettes',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'OFFSUP',
    description: 'Office Supplies',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'OVEN',
    description: 'OVEN',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PACKAGING',
    description: 'PACKAGING',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PADS',
    description: 'Pads',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PAL',
    description: 'Palletized Plastic packaging products-Clean',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PAPER',
    description: 'paper',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PAPERSHEE',
    description: 'PALLETS PAPER SHEETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PARTBOARD',
    description: 'PARTICLE BOARD',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PILLOWS',
    description: 'Pillows',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PIPES',
    description: 'Pipes and Tubing',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLANTS',
    description: 'Plants',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLASCORE',
    description: 'Plascore Meta-Aramid',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLASTICDI',
    description: 'Plastic dispensing parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLSLEEVES',
    description: 'ARTICLES OF PLASTIC SLEEVES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLSPRAYER',
    description: 'PLASTIC SPRAYERS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLSTCPUMP',
    description: 'PLASTIC PUMP ON PALLETS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PLSTRAP',
    description: 'Plastic Strapping',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'POTT',
    description: 'POTTING SOILS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PPBS',
    description: 'Polysulfone (plastic) bar stock',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PRESREG',
    description: 'Pressure Regulators',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PRESS',
    description: 'Press: Bed, Slide Assembly, Crow, etc.',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PRESWI',
    description: 'Pressure Switches',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PRINTED',
    description: 'Printed matter',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PULV',
    description: 'PULVERIZING EQUIPMENT',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'PUMP',
    description: 'PUMPS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RAWSTEEL',
    description: 'RAW STEEL',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RDBLDEQ',
    description: 'Road Building Equipment',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'REAC',
    description: 'Reactor',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RECARBON',
    description: 'Reactivated Carbon',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'REELS',
    description: 'Reels',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RESIN',
    description: 'RESIN',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ROLL',
    description: 'Solid Rolls',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ROLLER',
    description: 'ROLLERS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'ROLLPAP',
    description: 'Rolled/Packaged Paper (Clean)',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RS',
    description: 'Route Survey',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'RUBBER',
    description: 'RUBBER & PLASTIC',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SAFES',
    description: 'SAFES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SAFFIL',
    description: 'Rolls of Saffil Fibre',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SAILS',
    description: 'sails',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SALT',
    description: 'SALT IN BAGS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SAND',
    description: 'SAND',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SATELLITE',
    description: 'Satellite equipment',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SCHOOL',
    description: 'SCHOOL SUPPLIES',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SCRN/DRYW',
    description: 'SCREENING/DRYWALL',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SCULPTURE',
    description: 'sculptures',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SKIDSTEER',
    description: 'Skid Steer Attachments',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SOAP',
    description: 'cleaning compounds',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SOLARPAN',
    description: 'Solar Panels',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SSPIPE',
    description: 'Stainless Steel Pipe/Tube/Fittings',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'STEEL',
    description: 'Steel Articles',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'STEELTUB',
    description: 'Steel Tubing',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'STLSCREWS',
    description: 'Steel Screws & parts',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'STRATUBE',
    description: 'Straight Tubes',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'SUPPORTS',
    description: 'Supports',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TABLES',
    description: 'Tables',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TANKS',
    description: 'Tanks',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TILE',
    description: 'Tile or molding',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TIREADD',
    description: 'Tire Additives',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TIRES',
    description: 'Tires',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TOOL',
    description: 'Tooling Machinery Center',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TOPSOIL',
    description: 'TOP SOIL, FERTILIZERS BAGGED ON PALLET',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TRADESHOW',
    description: 'Trade Show',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TRAILER',
    description: 'TRAILER EQUIPMENT',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TRANSFORM',
    description: 'Transformer',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TRANSMIT',
    description: 'Transmitters',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TROP',
    description: '6/4/12oz Tropical Strawberry Hibiscus Vodka Cocktail',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TURBINE',
    description: 'Steam / Gas Turbine',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TURF',
    description: 'Turf',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'TWINE',
    description: 'TWINE',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'UTIL',
    description: 'UTILITY EQUIPMENT',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'VALVES',
    description: 'Valves',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WHEAT',
    description: 'Wheat',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WHEELLOAD',
    description: 'Wheel Loader',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WHEELS',
    description: 'Wheels',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WINDOW',
    description: 'WINDOW COVERINGS/BLINDS',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WINE',
    description: 'Wine',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WIRESPOOL',
    description: 'Wire on Spools',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WITCHHAZ',
    description: 'Witch Hazel',
    hazmat: 'N',
    un: '',
  },
  {
    code: 'WRBT',
    description: 'Wire Baskets',
    hazmat: 'N',
    un: '',
  },
];
